/**
 * OAuth2 provider configuration.
 *
 * Client IDs are read from environment variables at build time (CRA convention).
 * Create a `.env` in the frontend/dashboard/ directory with:
 *
 *   REACT_APP_GOOGLE_OAUTH_CLIENT_ID=your-google-client-id
 *   REACT_APP_GITHUB_OAUTH_CLIENT_ID=your-github-client-id
 *   REACT_APP_ORCID_OAUTH_CLIENT_ID=your-orcid-client-id
 */

const OAUTH_REDIRECT_URI =
  process.env.REACT_APP_OAUTH_REDIRECT_URI || "http://localhost:3000/auth/callback";

const OAUTH_PROVIDERS = {
  google: {
    name: "Google",
    clientId: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || "",
    authUrl: "https://accounts.google.com/o/oauth2/v2/auth",
    scope: "email profile",
  },
  github: {
    name: "GitHub",
    clientId: process.env.REACT_APP_GITHUB_OAUTH_CLIENT_ID || "",
    authUrl: "https://github.com/login/oauth/authorize",
    scope: "user:email",
  },
  orcid: {
    name: "ORCID",
    clientId: process.env.REACT_APP_ORCID_OAUTH_CLIENT_ID || "",
    authUrl: "https://orcid.org/oauth/authorize",
    scope: "/authenticate",
  },
};

/**
 * Build the full OAuth authorization URL for a provider.
 * The `state` query-param carries the provider key so the callback
 * component knows which backend endpoint to hit.
 */
function getOAuthUrl(provider) {
  const config = OAUTH_PROVIDERS[provider];
  if (!config || !config.clientId) return null;

  const params = new URLSearchParams({
    client_id: config.clientId,
    redirect_uri: OAUTH_REDIRECT_URI,
    response_type: "code",
    scope: config.scope,
    state: provider,
  });

  return `${config.authUrl}?${params.toString()}`;
}

/**
 * Same as getOAuthUrl but sets state = "<provider>:link" so that
 * OAuthCallback knows to hit the link endpoint instead of login.
 */
function getLinkOAuthUrl(provider) {
  const config = OAUTH_PROVIDERS[provider];
  if (!config || !config.clientId) return null;

  const params = new URLSearchParams({
    client_id: config.clientId,
    redirect_uri: OAUTH_REDIRECT_URI,
    response_type: "code",
    scope: config.scope,
    state: `${provider}:link`,
  });

  return `${config.authUrl}?${params.toString()}`;
}

export { OAUTH_PROVIDERS, OAUTH_REDIRECT_URI, getOAuthUrl, getLinkOAuthUrl };
